import React, { FC } from 'react'
import { Image } from 'react-native'

import { Stack } from '@zet/design-system'
import Avatar from '@zet/design-system/avatar/Avatar'
import Pressable from '@zet/design-system/pressable'

interface ProfileImageProps {
  name: string
  image: string
  onPress: () => void
}

const ProfileImage: FC<ProfileImageProps> = ({ name, image, onPress }) => {
  return (
    <Pressable
      className="h-7 w-7 items-center rounded-xl"
      style={{ overflow: 'hidden' }}
      onPress={onPress}
    >
      {image && !image.includes('null') ? (
        <Image
          source={{
            uri: image,
          }}
          style={{ height: '100%', width: 50 }}
        />
      ) : (
        <Stack className="p-1">
          <Avatar name={name} size="large" />
        </Stack>
      )}
    </Pressable>
  )
}

export { ProfileImage }
